import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { required, email, maxLength, numeric, minLength } from "vuelidate/lib/validators";
import { emailErrorMessagesMixin, stepForm, onlyNumbersMixin, onlyLettersMixin, lettersAndNumbersMixin } from "~/mixins";
import { withParams } from "vuelidate/lib/validators/common";
import { onlyLetters, onlyEmail, charactersSpecial, noSpecialChars } from "~/validators";
import { WarningError } from "~/abstractions/errors";
import template from "./functionals/autocomplete-template";
import { affiliationTypeEnum } from "~/enums";
import loader from "../modals/loader";
import { MasterApi } from "../../api";
import giroCorresponsalia from '~~/jsons/corresponsalia.json';
export default {
  mixins: [emailErrorMessagesMixin, stepForm, onlyNumbersMixin, onlyLettersMixin, lettersAndNumbersMixin],
  components: {
    loader: loader
  },
  data: function data() {
    var _$store$state$affilia = this.$store.state.affiliations.form.businessData,
        commercialAddress = _$store$state$affilia.commercialAddress,
        administrativeAddress = _$store$state$affilia.administrativeAddress,
        commerceData = _$store$state$affilia.commerceData;
    var _$store$state$master = this.$store.state["master-data"]["affiliation-in-process"],
        commercialAddressProvinces = _$store$state$master.commercialAddressProvinces,
        administrativeAddressProvinces = _$store$state$master.administrativeAddressProvinces,
        commercialAddressDistricts = _$store$state$master.commercialAddressDistricts,
        administrativeAddressDistricts = _$store$state$master.administrativeAddressDistricts;
    // console.log("jahc-------ajenttype",this.stAgentTType);

    return {
      isMultiAdress: false,
      listModelPos: [],
      selectModelPOS: [],
      modelPOS: false,
      modelPosActive: false,
      modalityTypes: [],
      posModel: "",
      agentType: "",
      agents: [],
      affiliationTypes: [],
      agentAffiliationType: "",
      days: ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"],
      multiDirections: [],
      newDays: [],
      startDay: "",
      endDay: "",
      startTime: "",
      endTime: "",
      modality: {},
      applyToPartnerPlan: false,
      autoCompleteComercial: "",
      isUpdating: false,
      sending: false,
      errorMessage: null,
      tradeName: commerceData.tradeName,
      email: commerceData.email,
      landline1: commercialAddress.landline,
      commercialBusiness: commerceData.commercialBusiness,
      nationalMcc: commerceData.nationalMcc,
      department1: commercialAddress.department,
      province1: commercialAddress.province,
      district1: commercialAddress.district,
      typeOfRoad1: commercialAddress.typeOfRoad,
      nameOfRoad1: commercialAddress.nameOfRoad,
      numberOfRoad1: commercialAddress.numberOfRoad,
      // plusCode1: commercialAddress.plusCode,
      km1: undefined,
      block1: undefined,
      allotment1: undefined,
      interiorType1: undefined,
      interior1: undefined,
      reference1: commercialAddress.reference,
      tmpTypeUrbanHabilitation1: undefined,
      typeUrbanHabilitation1: undefined,
      urbanHabilitation1: undefined,
      cellPhone1: commercialAddress.cellPhone,
      prefix1: commercialAddress.prefix,
      //   landline1: undefined,
      isTheSameDirection: true,
      addInformation: false,
      department2: administrativeAddress.department,
      province2: administrativeAddress.province,
      district2: administrativeAddress.district,
      typeOfRoad2: administrativeAddress.typeOfRoad,
      nameOfRoad2: administrativeAddress.nameOfRoad,
      numberOfRoad2: administrativeAddress.numberOfRoad,
      // plusCode2: administrativeAddress.plusCode,
      km2: undefined,
      block2: undefined,
      allotment2: undefined,
      interiorType2: undefined,
      interior2: undefined,
      reference2: administrativeAddress.reference,
      tmpTypeUrbanHabilitation2: undefined,
      typeUrbanHabilitation2: undefined,
      urbanHabilitation2: undefined,
      cellPhone2: administrativeAddress.cellPhone,
      prefix2: undefined,
      landline2: undefined,
      businessData: this.$store.state.affiliations.form.businessData,
      departments: this.$store.state["master-data"].departments,
      provinces: commercialAddressProvinces || [],
      districts: commercialAddressDistricts || [],
      provinces2: administrativeAddressProvinces || [],
      districts2: administrativeAddressDistricts || [],
      template: template,
      prueba: "",
      commercialAddress: {
        department: this.department1,
        province: this.province1,
        district: this.district1,
        typeOfRoad: this.typeOfRoad1,
        trackName: this.nameOfRoad1,
        trackNumber: this.numberOfRoad1,
        // plusCode: this.plusCode1,
        km: this.km1,
        block: this.block1,
        allotment: this.allotment1,
        interiorType: this.interiorType1,
        interior: this.interior1,
        reference: this.reference1,
        typeUrbanHabilitation: this.typeUrbanHabilitation1,
        urbanHabilitation: this.urbanHabilitation1,
        cellPhone: this.cellPhone1,
        prefix: this.prefix1,
        landline: this.landline1
      },
      membershipType: this.$store.state.affiliations.form.membershipType,
      visibleCheckbox: true,
      headers: [{
        text: 'Departamento',
        align: 'left',
        sortable: false,
        value: 'department'
      }, {
        text: 'Provincia',
        align: 'left',
        sortable: false,
        value: 'province'
      }, {
        text: 'Distrito',
        align: 'left',
        sortable: false,
        value: 'district'
      }, {
        text: 'Tipo de Via',
        align: 'left',
        sortable: false,
        value: 'typeOfRoad'
      }, {
        text: 'Nombre de Via',
        align: 'left',
        sortable: false,
        value: 'nameOfRoad'
      }, {
        text: 'Numero de Via',
        align: 'left',
        sortable: false,
        value: 'numberOfRoad'
      }, {
        text: 'Añadir Informacion',
        align: 'left',
        sortable: false,
        value: 'addInformation'
      }, {
        text: 'Añadir / Remover Direccion',
        align: 'left',
        sortable: false
      }]
      // applyToQR: false,
      // applyToQRForDistricts: false,
      // applyToCodeQR: false
    };
  },
  validations: function validations() {
    var validationsNotSameDirection = {
      modality: this.isPresential ? {
        required: required
      } : {},
      startDay: this.isPresential ? {
        required: required
      } : {},
      endDay: this.isPresential ? {
        required: required
      } : {},
      startTime: this.isPresential ? {
        required: required
      } : {},
      endTime: this.isPresential ? {
        required: required
      } : {},
      tradeName: {
        required: required,
        commercialName: withParams({ type: "commercialName" }, function (value) {
          return !/[ñÑáéíóúÁÉÍÓÚ|&]/.test(value);
        }),
        charactersSpecial: charactersSpecial("tradeName")
      },
      email: {
        required: required,
        // email,
        noSpecialChars: noSpecialChars("noSpecialChars"),
        emailValidate: onlyEmail("emailValidate")
      },
      district1: {
        required: required
      },
      province1: {
        required: required
      },
      department1: {
        required: required
      },
      typeOfRoad1: {
        required: required
      },
      nameOfRoad1: {
        required: required,
        charactersSpecial: charactersSpecial("nameOfRoad1")
      },
      numberOfRoad1: {
        required: required,
        numeric: numeric
      },
      reference1: {
        required: required,
        charactersSpecial: charactersSpecial("reference1")
      },
      cellPhone1: {
        required: required,
        minLength: minLength(9),
        numeric: numeric
      },
      landline1: {
        required: required,
        minLength: minLength(6),
        numeric: numeric
      },
      prefix1: {
        required: required,
        numeric: numeric,
        maxLength: maxLength(5)
      },
      prefix2: {
        required: required,
        numeric: numeric,
        maxLength: maxLength(5)
      },
      cellPhone2: {
        required: required,
        minLength: minLength(9),
        numeric: numeric
      },
      district2: {
        required: required
      },
      province2: {
        required: required
      },
      department2: {
        required: required
      },
      typeOfRoad2: {
        required: required
      },
      nameOfRoad2: {
        required: required,
        charactersSpecial: charactersSpecial("nameOfRoad2")
        // onlyLetters: onlyLetters("nameOfRoad2")
      },
      numberOfRoad2: {
        required: required,
        numeric: numeric
      },
      reference2: {
        required: required,
        charactersSpecial: charactersSpecial("reference2")
      },
      landline2: {
        required: required,
        numeric: numeric,
        minLength: minLength(7)
      },
      block1: {
        charactersSpecial: charactersSpecial("block1")
      },
      block2: {
        charactersSpecial: charactersSpecial("block2")
      },
      allotment1: {
        charactersSpecial: charactersSpecial("allotment1")
      },
      allotment2: {
        charactersSpecial: charactersSpecial("allotment2")
      },
      km1: {
        numeric: numeric
      },
      km2: {
        numeric: numeric
      },
      urbanHabilitation1: {
        required: this.tmpTypeUrbanHabilitation1 ? required : false,
        charactersSpecial: charactersSpecial("urbanHabilitation1")
      },
      urbanHabilitation2: {
        required: this.tmpTypeUrbanHabilitation2 ? required : false,
        charactersSpecial: charactersSpecial("urbanHabilitation2")
      },
      interior1: {
        charactersSpecial: charactersSpecial("interior1")
      },
      interior2: {
        charactersSpecial: charactersSpecial("interior2")
      }
    };
    var validationsSameDirection = {
      modality: this.isPresential ? {
        required: required
      } : {},
      startDay: this.isPresential ? {
        required: required
      } : {},
      endDay: this.isPresential ? {
        required: required
      } : {},
      startTime: this.isPresential ? {
        required: required
      } : {},
      endTime: this.isPresential ? {
        required: required
      } : {},
      tradeName: {
        required: required,
        commercialName: withParams({ type: "commercialName" }, function (value) {
          return !/[ñÑáéíóúÁÉÍÓÚ|&]/.test(value);
        }),
        charactersSpecial: charactersSpecial("tradeName")
      },
      email: {
        required: required,
        // email,
        noSpecialChars: noSpecialChars("noSpecialChars"),
        emailValidate: onlyEmail("emailValidate")
      },
      nameOfRoad1: {
        required: required,
        // onlyLetters: onlyLetters("nameOfRoad1")
        charactersSpecial: charactersSpecial("nameOfRoad1")
      },
      numberOfRoad1: {
        required: required,
        numeric: numeric
      },
      reference1: {
        required: required,
        charactersSpecial: charactersSpecial("reference1")
      },
      cellPhone1: {
        required: required,
        minLength: minLength(9),
        numeric: numeric
      },
      district1: {
        required: required
      },
      province1: {
        required: required
      },
      department1: {
        required: required
      },
      typeOfRoad1: {
        required: required
      },
      landline1: {
        required: required,
        minLength: minLength(6),
        numeric: numeric
      },
      prefix1: {
        required: required,
        numeric: numeric,
        maxLength: maxLength(5)
      },
      block1: {
        charactersSpecial: charactersSpecial("block1")
      },
      allotment1: {
        charactersSpecial: charactersSpecial("allotment1")
      },
      km1: {
        numeric: numeric
      },
      interior1: {
        charactersSpecial: charactersSpecial("interior1")
      },
      urbanHabilitation1: {
        required: this.tmpTypeUrbanHabilitation1 ? required : false,
        charactersSpecial: charactersSpecial("urbanHabilitation1")
      }
    };
    if (!this.isTheSameDirection) {
      //Valido los dos interiores
      if (this.interiorType1) {
        validationsNotSameDirection.interior1.required = required;
      }
      if (this.interiorType2) {
        validationsNotSameDirection.interior2.required = required;
      }
      return validationsNotSameDirection;
    } else {
      //Valido solo el interior1
      if (this.interiorType1) {
        validationsSameDirection.interior1.required = required;
      }
      return validationsSameDirection;
    }
  },

  methods: _extends({}, mapActions({
    getProvince: "master-data/getProvince",
    getDistrict: "master-data/getDistrict"
  }), mapMutations({
    setEquipmentType: "affiliations/form/setEquipmentType",
    setEsPOSPinpadMpos: "affiliations/form/setEsPOSPinpadMpos",
    setMultiAdress: "affiliations/form/setMultiAdress",
    setinMultiAdressisSameDirection: "affiliations/form/setinMultiAdressisSameDirection"
  }), {
    containsOnlyNumbers: function containsOnlyNumbers(text) {
      var regex = /[^0-9]/;
      return !regex.test(text);
    },
    preventNumbers: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var pastedText;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pastedText = event.clipboardData.getData('text');

                if (!this.containsOnlyNumbers(pastedText)) {
                  event.preventDefault();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function preventNumbers(_x) {
        return _ref.apply(this, arguments);
      }

      return preventNumbers;
    }(),
    getMdelPosByProduct: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref3, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new MasterApi(this.$axios).findModelPosByProduct({
                  nameProduct: this.$store.state.affiliations.form.productChoice
                });

              case 2:
                _ref3 = _context2.sent;
                data = _ref3.data;

                this.listModelPos = data;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMdelPosByProduct() {
        return _ref2.apply(this, arguments);
      }

      return getMdelPosByProduct;
    }(),
    getInfo: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var selectedModelPos;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getMdelPosByProduct();

              case 2:
                //llena el campo modalidad y modelo en caso existan
                if (this.$store.state.affiliations.form.productChoice && this.$store.state.affiliations.form.modalityType.type) {
                  this.modality = {
                    id: this.$store.state.affiliations.form.modalityType.type,
                    title: this.$store.state.affiliations.form.typeModalityTitle
                  };
                  if (this.$store.state.affiliations.form.tipoEquipo) {
                    console.log("Setting tipo de equipo", this.$store.state.affiliations.form.tipoEquipo);
                    console.log(this.listModelPos);
                    selectedModelPos = this.listModelPos.find(function (row) {
                      return row.EquipmentType === _this.$store.state.affiliations.form.tipoEquipo;
                    });

                    this.posModel = {
                      id: selectedModelPos.EquipmentType,
                      pos: selectedModelPos.POS
                    };
                    console.log(selectedModelPos);
                  }
                }
                //Llena Dia Inicio - Fin y Hora Inicio Fin
                if (this.$store.state.affiliations.form.businessSchedule) {
                  this.startTime = this.$store.state.affiliations.form.businessSchedule.startTime;
                  this.endTime = this.$store.state.affiliations.form.businessSchedule.endTime;
                  this.startDay = this.days[this.$store.state.affiliations.form.businessSchedule.schedule[0]];
                  this.endDay = this.days[this.$store.state.affiliations.form.businessSchedule.schedule.length - 1];
                }
                console.log("POS Model", this.posModel);
                console.log("Modalidad", this.modality.title);
                console.log(this.$store.state.affiliations.form.productChoice == "POS Inalámbrico" && this.modality.title == "Venta Básica" || this.modality.title == "Alquiler");
                //llena agente y tipo de afiliacion de corresponsalía	  
                if (this.$store.state.affiliations.form.productChoice == 'Corresponsalía') {
                  this.agentType = this.$store.state.affiliations.form.corresponsaliaData.header.agent ? this.$store.state.affiliations.form.corresponsaliaData.header.agent : null;
                  this.agentAffiliationType = this.$store.state.affiliations.form.corresponsaliaData.header.affiliationType ? this.$store.state.affiliations.form.corresponsaliaData.header.affiliationType : null;
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getInfo() {
        return _ref4.apply(this, arguments);
      }

      return getInfo;
    }(),
    getStartDay: function getStartDay() {
      if (this.startDay) return false;
      return true;
    },
    createMapAddress: function createMapAddress(typeOfRoad, nameOfRoad, numberOfRoad, departament, province, district) {
      var scopeProvince = "Lima";
      if (province) scopeProvince = province.Name;

      var tmpArray = [typeOfRoad.Name || null, nameOfRoad || null, numberOfRoad || null, district.Name || null, scopeProvince || null, departament.Name || null];
      var stringConcat = tmpArray.filter(function (item) {
        return item !== null;
      }).join(" ");
      return (stringConcat + " Per\xFA").toLowerCase();
    },
    listenerAutocomplete: function listenerAutocomplete() {
      // console.log("val");
    },
    consultMcci: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(mcci) {
        var data, _ref6, statusCode, internalStatusCode, internalStatusDescription, _ref7, codigo, mensaje;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (mcci) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                this.$refs.loaderModal.showLoader();

                // console.log('mcci: ', mcci)

                // const noMccInternational = [4511, 3102, 3052, 3010, 4722, 3039, 3007, 3030, 3001, 3219, 3076, 3011, 3127, 3221, 3012, 3009, 3248, 3013, 3082, 7512, 4121, 7995, 5734, 5045, 5072, 5813, 8220, 8211, 8249, 8241, 7922, 7538, 5533, 5511, 7542, 5521, 7832, 5541, 3503, 3513, 3649, 3637, 3750, 3634, 3692, 3830, 3509, 3548, 3642, 3533, 3591, 3504, 3778, 5211, 5712, 4900, 5172, 7991, 7998, 5542, 5021, 7032, 5960, 5122, 9311, 5309]
                // const result = noMccInternational.find(code => code === Number(mcci))
                // result ? this.visibleCheckbox = false : this.visibleCheckbox = true

                // const riskyTurns = [5331, 5399, 5999, 5933, 6012, 6051, 4829, 6051, 7993, 7995, 8651]
                // const prohibitedTurns = [5968, 5962, 5967, 5960, 5969, 5966, 5964, 5993, 7995, 7801, 7802, 5912, 5122]

                // const findRiskyTurns = riskyTurns.find(code => code === Number(mcci))
                // const findProhibitedTurns = prohibitedTurns.find(code => code === Number(mcci))

                // if (findRiskyTurns || findProhibitedTurns) this.applyToQR = false
                // else this.applyToQR = true

                _context4.prev = 3;

                // console.log("mcci", mcci);
                console.log(this.rucValidation);
                data = {
                  audit: {
                    appId: "PCRM001V1",
                    usuario: "",
                    ipServidor: "",
                    transaccionId: "",
                    origen: ""
                  },
                  obtenerComisionesRequest: {
                    cliente: {
                      ruc: this.rucValidation.ruc,
                      oportunidad: {
                        producto: "",
                        subProducto: "",
                        mccInternacional: mcci,
                        plataforma: ""
                      }
                    }
                  }
                };
                _context4.next = 8;
                return this.$store.dispatch("affiliations/form/consultMcci", mcci);

              case 8:
                _ref6 = _context4.sent;
                statusCode = _ref6.statusCode;
                internalStatusCode = _ref6.internalStatusCode;
                internalStatusDescription = _ref6.internalStatusDescription;

                if (!(statusCode !== "0")) {
                  _context4.next = 19;
                  break;
                }

                _context4.t0 = internalStatusCode;
                _context4.next = 16;
                break;

              case 16:
                throw new WarningError(internalStatusDescription);

              case 17:
                _context4.next = 30;
                break;

              case 19:
                _context4.next = 21;
                return this.$store.dispatch("affiliations/form/consultComision", data);

              case 21:
                _ref7 = _context4.sent;
                codigo = _ref7.codigo;
                mensaje = _ref7.mensaje;

                if (!(codigo !== "0000")) {
                  _context4.next = 30;
                  break;
                }

                if (mensaje) {
                  _context4.next = 29;
                  break;
                }

                throw new WarningError("El servicio no se encuentra disponible.");

              case 29:
                throw new WarningError(mensaje);

              case 30:
                _context4.next = 35;
                break;

              case 32:
                _context4.prev = 32;
                _context4.t1 = _context4["catch"](3);

                // console.log(error);
                this.$controlMessage(_context4.t1);

              case 35:
                try {
                  this.$refs.loaderModal.closeLoader();
                } catch (error) {}

              case 36:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 32]]);
      }));

      function consultMcci(_x2) {
        return _ref5.apply(this, arguments);
      }

      return consultMcci;
    }(),
    validateType: function validateType() {
      if (this.isPresential && this.productChoice === "POS Inalámbrico") {
        this.modalityTypes = [{
          id: 1,
          title: "Venta Básica"
        }, {
          id: 3,
          title: "Venta Extendida"
        }, {
          id: 2,
          title: "Alquiler"
        }];
      } else {
        this.modalityTypes = [{
          id: 2,
          title: "Alquiler"
        }];
      }
    },
    getCodeFromName: function getCodeFromName(value) {
      var codeValue = this.names.filter(function (item) {
        return item.Name === value;
      });
      if (codeValue && codeValue.length > 0 && codeValue[0] && codeValue[0].Code) {
        return {
          Code: codeValue[0].Code,
          Name: codeValue[0].Name,
          IdTypeUrbanHabilitation: codeValue[0].IdTypeUrbanHabilitation
        };
      }
    },
    onSubmit: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var adressMulti, tempDiirs, messagePhone, celular1, celular2, results, _results, timestamp, _ref9, existeCorreo, responseServer, _email, serverIp, _ref10, statusCode, internalStatusCode, internalStatusDescription, refData;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.sending = true;
                this.$refs.loaderModal.showLoader();
                _context5.prev = 2;

                //Guardamos el MultiAddress
                adressMulti = [];

                this.multiDirections.forEach(function (item) {
                  if (item.department && item.department.IdDepartament && item.province && item.province.IdProvince && item.district && item.district.IdDistrict && item.typeOfRoad && item.typeOfRoad.IdTypeOfRoad && item.nameOfRoad && item.nameOfRoad.length > 0 && item.numberOfRoad && item.numberOfRoad.length > 0) adressMulti.push(item);
                });
                tempDiirs = _JSON$stringify(adressMulti);

                this.setMultiAdress(JSON.parse(tempDiirs));
                //almacena datos del agente
                // if ($isCorresponsalia()){
                //     this.$store.dispatch("affiliations/form/setAgentData", {              
                //     });
                // }
                // servicio para verificar el telefono
                messagePhone = "";
                celular1 = this.cellPhone1;
                celular2 = this.isTemporalAffiliationOrIsSameCommercialAddress ? this.cellPhone1 : this.cellPhone2;

                if (!(celular1 === celular2)) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 13;
                return _Promise.all([this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                  phone: celular1
                })]);

              case 13:
                results = _context5.sent;


                if (!results[0].code) messagePhone = "Tel\xE9fono Celular 1 : " + results[0].message + "\n";
                _context5.next = 22;
                break;

              case 17:
                _context5.next = 19;
                return _Promise.all([this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                  phone: celular1
                }), this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                  phone: celular2
                })]);

              case 19:
                _results = _context5.sent;


                if (!_results[0].code) messagePhone = "Tel\xE9fono Celular 1 : " + _results[0].message + "\n";
                if (!_results[1].code) messagePhone = "Tel\xE9fono Celular 2: " + _results[1].message + "\n";

              case 22:
                if (!messagePhone) {
                  _context5.next = 26;
                  break;
                }

                this.$swal("Aviso", messagePhone, "warning");
                _context5.next = 79;
                break;

              case 26:
                // servicio para verificar correo
                timestamp = Date.now();
                _context5.next = 29;
                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                  transaccionId: timestamp,
                  correo: this.email.toLowerCase()
                });

              case 29:
                _ref9 = _context5.sent;
                existeCorreo = _ref9.existeCorreo;
                responseServer = _ref9.responseServer;
                _email = _ref9.email;
                serverIp = _ref9.serverIp;

                if (!(responseServer === "Error")) {
                  _context5.next = 40;
                  break;
                }

                this.$swal("Error", "Error en el servicio. Vuelva a intentarlo mas tarde.", "error");
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context5.next = 79;
                break;

              case 40:
                if (!existeCorreo) {
                  _context5.next = 76;
                  break;
                }

                this.$v.$touch();

                if (!this.$v.$invalid) {
                  _context5.next = 44;
                  break;
                }

                return _context5.abrupt("return");

              case 44:
                _context5.prev = 44;
                _context5.next = 47;
                return this.$store.dispatch("affiliations/form/saveBusinessSchedule", {
                  startTime: this.startTime || "",
                  endTime: this.endTime || "",
                  schedule: this.arrayNew,
                  initDay: "0900AM",
                  endDay: "0500PM"
                });

              case 47:
                _context5.next = 49;
                return this.$store.dispatch("affiliations/form/validateCrmOpportunity", {
                  phoneMobile: this.cellPhone1,
                  phoneWork: this.prefix1 + this.landline1
                });

              case 49:
                _ref10 = _context5.sent;
                statusCode = _ref10.statusCode;
                internalStatusCode = _ref10.internalStatusCode;
                internalStatusDescription = _ref10.internalStatusDescription;
                refData = _ref10.refData;

                if (!(statusCode !== "0")) {
                  _context5.next = 59;
                  break;
                }

                _context5.t0 = internalStatusCode;
                _context5.next = 58;
                break;

              case 58:
                throw new WarningError(internalStatusDescription);

              case 59:
                if (this.isPresential)
                  // await this.$store.dispatch("affiliations/form/modalityType", {
                  //   type: this.modality.title,
                  //   currencyType:null
                  // });
                  this.$store.commit("affiliations/form/setTypeModalityTitle", this.modality.title);
                console.log("start corresponsalia data");
                _context5.next = 63;
                return this.$store.dispatch("affiliations/form/saveCorresponsaliaData", {
                  agent: this.$isCorresponsalia() ? this.agentType : null,
                  affiliationType: this.$isCorresponsalia() ? this.agentAffiliationType : null
                });

              case 63:
                console.log("Finishing corresponsalia data");
                _context5.next = 66;
                return this.$store.dispatch("affiliations/form/saveBusinessData", {
                  adminCommerEquals: this.isTheSameDirection,
                  // applyToCodeQR: this.applyToCodeQR,
                  refData: refData,
                  commerceData: {
                    tradeName: this.tradeName,
                    email: this.email,
                    commercialBusiness: this.commercialBusiness,
                    nationalMcc: this.commercialBusiness.Code,
                    applyToPartnerPlan: this.applyToPartnerPlan
                  },
                  commercialAddress: {
                    department: this.department1 || 0,
                    province: this.province1 || 0,
                    district: this.district1 || 0,
                    typeOfRoad: this.typeOfRoad1,
                    nameOfRoad: this.nameOfRoad1,
                    numberOfRoad: this.numberOfRoad1,
                    km: this.km1,
                    block: this.block1,
                    // plusCode: this.plusCode1,
                    allotment: this.allotment1,
                    interiorType: this.interiorType1,
                    interior: this.interior1,
                    reference: this.reference1,
                    typeUrbanHabilitation: this.typeUrbanHabilitation1,
                    urbanHabilitation: this.urbanHabilitation1,
                    cellPhone: this.cellPhone1,
                    prefix: this.prefix1,
                    landline: this.landline1
                  },
                  administrativeAddress: {
                    department: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.department1 : this.department2,
                    province: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.province1 : this.province2,
                    district: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.district1 : this.district2,
                    typeOfRoad: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.typeOfRoad1 : this.typeOfRoad2,
                    nameOfRoad: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.nameOfRoad1 : this.nameOfRoad2,
                    numberOfRoad: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.numberOfRoad1 : this.numberOfRoad2,
                    km: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.km1 : this.km2,
                    block: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.block1 : this.block2,
                    // plusCode: this.isTemporalAffiliationOrIsSameCommercialAddress
                    //   ? this.plusCode1
                    //   : this.plusCode2,
                    allotment: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.allotment1 : this.allotment2,
                    interiorType: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.interiorType1 : this.interiorType2,
                    interior: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.interior1 : this.interior2,
                    reference: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.reference1 : this.reference2,
                    typeUrbanHabilitation: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.typeUrbanHabilitation1 : this.typeUrbanHabilitation2,
                    urbanHabilitation: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.urbanHabilitation1 : this.urbanHabilitation2,
                    cellPhone: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.cellPhone1 : this.cellPhone2,
                    prefix: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.prefix1 : this.prefix2,
                    landline: this.isTemporalAffiliationOrIsSameCommercialAddress ? this.landline1 : this.landline2
                  }
                });

              case 66:
                _context5.next = 72;
                break;

              case 68:
                _context5.prev = 68;
                _context5.t1 = _context5["catch"](44);

                this.$controlMessage(_context5.t1);
                this.$refs.loaderModal.closeLoader();

              case 72:
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context5.next = 79;
                break;

              case 76:
                this.$swal("Aviso", "No existe el correo " + this.email + ", ingresar uno correcto.", "warning");
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 79:
                _context5.next = 87;
                break;

              case 81:
                _context5.prev = 81;
                _context5.t2 = _context5["catch"](2);

                console.log(">>Error Onsubmit", _context5.t2.message);
                this.$swal("Aviso", "El correo ingresado tiene formato incorrecto.", "warning");
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 87:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 81], [44, 68]]);
      }));

      function onSubmit() {
        return _ref8.apply(this, arguments);
      }

      return onSubmit;
    }(),
    reset: function reset() {
      this.$v.$reset();
      this.email = "";
      this.emailSended = false;
    },
    addAdress: function addAdress(index) {
      this.isMultiAdress = true;
      if (this.multiDirections.length <= 200) {
        if (this.multiDirections.length === 0) {
          this.multiDirections.push({
            department: this.department1,
            province: this.province1,
            district: this.district1,
            typeOfRoad: this.typeOfRoad1,
            nameOfRoad: this.nameOfRoad1,
            numberOfRoad: this.numberOfRoad1,
            km: this.km1,
            block: this.block1,
            allotment: this.allotment1,
            interiorType: this.interiorType1,
            interior: this.interior1,
            tmpTypeUrbanHabilitation: this.getCodeFromName(this.tmpTypeUrbanHabilitation1),
            urbanHabilitation: this.urbanHabilitation1,
            addInformation: this.addInformation,
            typeUrbanHabilitation: this.typeUrbanHabilitation,
            provinces: this.provinces,
            districts: this.districts
          });
          var reftp = document.getElementById("tableMulti");
          reftp.scrollIntoView({ behavior: 'smooth' });
        }
        this.multiDirections.push({
          department: '',
          province: '',
          district: '',
          typeOfRoad: '',
          nameOfRoad: '',
          numberOfRoad: '',
          km: undefined,
          block: undefined,
          allotment: undefined,
          interiorType: undefined,
          interior: undefined,
          tmpTypeUrbanHabilitation: undefined,
          urbanHabilitation: undefined,
          addInformation: undefined,
          provinces: [],
          districts: [],
          typeUrbanHabilitation: undefined
        });
        if (index) {
          var reftpElement = document.getElementById("element-" + index);
          reftpElement.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        throw new WarningError("El numero máximo de direcciones son 200");
      }
    },
    removeAdress: function removeAdress(index) {
      if (index !== 0) {
        this.multiDirections.splice(index, 1);
      }
    },
    changeDepartament: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(index) {
        var objDepartament;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                objDepartament = this.multiDirections[index].department;
                _context6.next = 3;
                return this.getProvince({
                  departmentId: objDepartament.IdDepartament
                });

              case 3:
                this.multiDirections[index].provinces = _context6.sent;

                if (index === 0) {
                  this.$v.department1.$touch();
                  this.provinces = this.multiDirections[index].provinces;
                  this.department1 = this.multiDirections[index].department;
                }

                this.prefix1 = objDepartament.TelephonePrefix;

                this.multiDirections[index].province = "";
                this.multiDirections[index].district = "";

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function changeDepartament(_x3) {
        return _ref11.apply(this, arguments);
      }

      return changeDepartament;
    }(),
    changeProvince: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(index) {
        var objDepartament, objProvince;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                objDepartament = this.multiDirections[index].department;
                objProvince = this.multiDirections[index].province;
                _context7.next = 4;
                return this.getDistrict({
                  departmentId: objDepartament.IdDepartament,
                  provinceId: objProvince.IdProvince
                });

              case 4:
                this.multiDirections[index].districts = _context7.sent;

                if (index === 0) {
                  this.$v.province1.$touch();
                  this.districts = this.multiDirections[index].districts;
                  this.province1 = this.multiDirections[index].province;
                }
                this.multiDirections[index].district = "";

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function changeProvince(_x4) {
        return _ref12.apply(this, arguments);
      }

      return changeProvince;
    }(),
    changetmpTypeUrbanHabilitation: function changetmpTypeUrbanHabilitation(index) {
      var value = this.multiDirections[index].tmpTypeUrbanHabilitation;
      this.multiDirections[index].typeUrbanHabilitation = this.getCodeFromName(value);
      if (index === 0) this.typeUrbanHabilitation1 = this.getCodeFromName(value);
    },
    cambionameVia: function cambionameVia(index) {
      this.$v.nameOfRoad1.$touch();
      this.nameOfRoad1 = this.multiDirections[index].nameOfRoad;
    },
    cambionumVia: function cambionumVia(index) {
      this.$v.numberOfRoad1.$touch();
      this.numberOfRoad1 = this.multiDirections[index].numberOfRoad;
    },
    cambioDistrito: function cambioDistrito(index) {
      this.$v.district1.$touch();
      this.district1 = this.multiDirections[index].district;
    },
    cambioTypeRoad: function cambioTypeRoad(index) {
      this.$v.typeOfRoad1.$touch();
      this.typeOfRoad1 = this.multiDirections[index].typeOfRoad;
    },
    loadAgents: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return new MasterApi(this.$axios).findAllAllAgent();

              case 2:
                data = _context8.sent;

                this.agents = data;

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function loadAgents() {
        return _ref13.apply(this, arguments);
      }

      return loadAgents;
    }(),
    loadAffilitationTypes: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var data;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return new MasterApi(this.$axios).findAllAllAffiliationType();

              case 2:
                data = _context9.sent;

                this.affiliationTypes = data;

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function loadAffilitationTypes() {
        return _ref14.apply(this, arguments);
      }

      return loadAffilitationTypes;
    }()
  }),
  watch: {
    posModel: function posModel(value) {
      this.setEquipmentType(value.id);
      console.log(this.$store.state.affiliations.form.tipoEquipo);
    },
    modality: function modality(value) {
      var _this2 = this;

      console.log("Verificando modality", value);
      console.log("this.listModelPos", this.listModelPos);

      this.listModelPos.forEach(function (pos) {
        if (pos.Modality.includes(value.title)) {
          _this2.modelPosActive = true;
          _this2.selectModelPOS.push({ id: pos.EquipmentType, pos: pos.POS });
          console.log(pos.EquipmentType);
          /* this.setEquipmentType() */
        } else {
          _this2.modelPosActive = false;
          _this2.selectModelPOS = [];
        }
      });
    },
    tmpTypeUrbanHabilitation1: function tmpTypeUrbanHabilitation1(value) {
      this.typeUrbanHabilitation1 = this.getCodeFromName(value);
    },
    tmpTypeUrbanHabilitation2: function tmpTypeUrbanHabilitation2(value) {
      this.typeUrbanHabilitation2 = this.getCodeFromName(value);
    },
    department1: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(this.multiDirections.length == 0)) {
                  _context10.next = 9;
                  break;
                }

                console.log("no entres please");
                _context10.next = 4;
                return this.getProvince({
                  departmentId: id.IdDepartament
                });

              case 4:
                this.provinces = _context10.sent;

                this.province1 = "";
                this.district1 = "";
                this.prefix1 = id.TelephonePrefix;
                console.log("department 1:" + id.IdDepartament);

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function department1(_x5) {
        return _ref15.apply(this, arguments);
      }

      return department1;
    }(),
    province1: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(id) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(this.multiDirections.length == 0)) {
                  _context11.next = 7;
                  break;
                }

                console.log("no entres please1");
                _context11.next = 4;
                return this.getDistrict({
                  departmentId: this.department1.IdDepartament,
                  provinceId: id.IdProvince
                });

              case 4:
                this.districts = _context11.sent;

                this.district1 = "";
                console.log("province 1:" + id.IdProvince);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function province1(_x6) {
        return _ref16.apply(this, arguments);
      }

      return province1;
    }(),
    district1: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function district1() {
        return _ref17.apply(this, arguments);
      }

      return district1;
    }(),
    department2: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.getProvince({
                  departmentId: id.IdDepartament
                });

              case 2:
                this.provinces2 = _context13.sent;

                this.province2 = "";
                this.district2 = "";
                this.prefix2 = id.TelephonePrefix;
                console.log("department 2:" + id.IdDepartament);

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function department2(_x7) {
        return _ref18.apply(this, arguments);
      }

      return department2;
    }(),
    province2: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(id) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.getDistrict({
                  departmentId: this.department2.IdDepartament,
                  provinceId: id.IdProvince
                });

              case 2:
                this.districts2 = _context14.sent;

                this.district2 = "";
                console.log("province 2:" + id.IdProvince);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function province2(_x8) {
        return _ref19.apply(this, arguments);
      }

      return province2;
    }()
  },
  computed: _extends({}, mapState({
    rucValidation: function rucValidation(state) {
      return state.affiliations.form.rucValidation;
    },
    commercialBusinessOptions: function commercialBusinessOptions(state) {
      return state["master-data"].conglomerateTypes;
    },
    opNationalMcc: function opNationalMcc(state) {
      return state["master-data"].opNationalMcc;
    },
    opCommercialBusiness: function opCommercialBusiness(state) {
      return state["master-data"].opCommercialBusiness;
    },
    opCommercialBusinessCorresponsalia: function opCommercialBusinessCorresponsalia(state) {
      return state["master-data"].opCommercialBusiness.filter(function (item) {
        return giroCorresponsalia.includes(item.Code);
      });
    },
    typeRoads: function typeRoads(state) {
      return state["master-data"].typeRoads;
    },
    typeInteriors: function typeInteriors(state) {
      return state["master-data"].typeInteriors;
    },
    names: function names(state) {
      return state["master-data"].names;
    },
    isPresential: function isPresential(state) {
      return state.affiliations.form.productType === "1";
    },
    productChoice: function productChoice(state) {
      return state.affiliations.form.productChoice;
    },
    multiAdress: function multiAdress(state) {
      return state.affiliations.form.multiAdress;
    },
    inMultiAdressisSameDirection: function inMultiAdressisSameDirection(state) {
      return state.affiliations.form.inMultiAdressisSameDirection;
    }
  }), mapGetters({
    isValidConsultMcci: "affiliations/form/isValidConsultMcci"
  }), {
    firstMapAddress: function firstMapAddress() {
      return this.createMapAddress(this.typeOfRoad1, this.nameOfRoad1, this.numberOfRoad1, this.department1, this.province1, this.district1);
    },
    secondMapAddress: function secondMapAddress() {
      return this.createMapAddress(this.typeOfRoad2, this.nameOfRoad2, this.numberOfRoad2, this.department2, this.province2, this.district2);
    },
    prefix1ErrorMessages: function prefix1ErrorMessages() {
      var errors = [];
      if (!this.$v.prefix1.$dirty) return errors;
      !this.$v.prefix1.required && errors.push("Campo obligatorio"), !this.$v.prefix1.numeric && errors.push("Ingresa sólo números");
      return errors;
    },
    prefix2ErrorMessages: function prefix2ErrorMessages() {
      var errors = [];
      if (!this.$v.prefix2.$dirty) return errors;
      !this.$v.prefix2.required && errors.push("Campo obligatorio"), !this.$v.prefix2.numeric && errors.push("Ingresa sólo números");
      return errors;
    },
    getDays: function getDays() {
      var _this3 = this;

      if (this.startDay) {
        var index = this.days.findIndex(function (d) {
          return d === _this3.startDay;
        });
        return this.days.slice(index, this.days.length + 1);
      } else return this.days;
    },
    arrayNew: function arrayNew() {
      var _this4 = this;

      var arrayNew = [-1, -1, -1, -1, -1, -1, -1];
      var index = this.days.findIndex(function (d) {
        return d === _this4.startDay;
      });
      var length = this.days.findIndex(function (d) {
        return d === _this4.endDay;
      }) + 1;
      for (var i = index; i < length; i++) {
        arrayNew[i] = i;
      }
      return arrayNew;
    },


    // applyToCodeQrFix() {
    //   let response = false
    //   if (this.province1.IdProvince === 128 && this.district1 && this.$isPresential() && this.applyToQR) {this.applyToCodeQR = true, response = true}
    //   else this.applyToCodeQR = false
    //   return response
    // },

    tradeNameErrorMessages: function tradeNameErrorMessages() {
      var errors = [];
      if (!this.$v.tradeName.$dirty) return errors;
      !this.$v.tradeName.required && errors.push("Campo obligatorio"), !this.$v.tradeName.commercialName && errors.push("No puedes escribir ñ, &, | ó tildes"), !this.$v.tradeName.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    nameOfRoad1ErrorMessages: function nameOfRoad1ErrorMessages() {
      var errors = [];
      if (!this.$v.nameOfRoad1.$dirty) return errors;
      !this.$v.nameOfRoad1.required && errors.push("Campo obligatorio"),
      // console.log(!this.$v.nameOfRoad1);
      !this.$v.nameOfRoad1.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    numberOfRoad1ErrorMessages: function numberOfRoad1ErrorMessages() {
      var errors = [];
      if (!this.$v.numberOfRoad1.$dirty) return errors;
      !this.$v.numberOfRoad1.required && errors.push("Campo obligatorio"), !this.$v.numberOfRoad1.numeric && errors.push("Ingresa sólo números");
      return errors;
    },
    reference1ErrorMessages: function reference1ErrorMessages() {
      var errors = [];
      if (!this.$v.reference1.$dirty) return errors;
      !this.$v.reference1.required && errors.push("Campo obligatorio"), !this.$v.reference1.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    cellPhone1ErrorMessages: function cellPhone1ErrorMessages() {
      var errors = [];
      if (!this.$v.cellPhone1.$dirty) return errors;
      !this.$v.cellPhone1.required && errors.push("Campo obligatorio"), !this.$v.cellPhone1.numeric && errors.push("Ingrese sólo números"), !this.$v.cellPhone1.minLength && errors.push("Ingrese como minímo 9 números");
      return errors;
    },
    landline1ErrorMessages: function landline1ErrorMessages() {
      var errors = [];
      if (!this.$v.landline1.$dirty) return errors;
      !this.$v.landline1.required && !(typeof this.$v.landline1.required == "undefined") && errors.push("Campo obligatorio"), !this.$v.landline1.numeric && errors.push("Ingrese sólo números"), this.department1.IdDepartament != 15 && this.department1.IdDepartament != 7 ? !this.$v.landline1.minLength && errors.push("Ingrese mínimo 6 números") : !this.$v.landline1.minLength && errors.push("Ingrese mínimo 7 números");

      return errors;
    },
    endTimeErrorMessages: function endTimeErrorMessages() {
      var errors = [];
      if (!this.$v.endTime.$dirty) return errors;
      if (!this.$v.endTime.required && !(typeof this.$v.endTime.required == "undefined")) errors.push("Campo obligatorio");
      if (this.startTime && this.endTime) if (this.startTime > this.endTime) errors.push("Hora Fin debe de ser mayor que la Hora Inicio");
      return errors;
    },

    //Administrative Address
    nameOfRoad2ErrorMessages: function nameOfRoad2ErrorMessages() {
      var errors = [];
      if (!this.$v.nameOfRoad2.$dirty) return errors;
      !this.$v.nameOfRoad2.required && errors.push("Campo obligatorio");
      !this.$v.nameOfRoad2.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    numberOfRoad2ErrorMessages: function numberOfRoad2ErrorMessages() {
      var errors = [];
      if (!this.$v.numberOfRoad2.$dirty) return errors;
      !this.$v.numberOfRoad2.required && errors.push("Campo obligatorio"), !this.$v.numberOfRoad2.numeric && errors.push("Ingrese sólo números");
      return errors;
    },
    reference2ErrorMessages: function reference2ErrorMessages() {
      var errors = [];
      if (!this.$v.reference2.$dirty) return errors;
      !this.$v.reference2.required && errors.push("Campo obligatorio"), !this.$v.reference2.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    urbanHabilitation1ErrorMessages: function urbanHabilitation1ErrorMessages() {
      var errors = [];
      if (!this.$v.urbanHabilitation1.$dirty) return errors;
      !this.$v.urbanHabilitation1.required && errors.push("Campo obligatorio");
      !this.$v.urbanHabilitation1.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    urbanHabilitation2ErrorMessages: function urbanHabilitation2ErrorMessages() {
      var errors = [];
      if (!this.$v.urbanHabilitation2.$dirty) return errors;
      !this.$v.urbanHabilitation2.required && errors.push("Campo obligatorio");
      !this.$v.urbanHabilitation2.charactersSpecial && errors.push("No puedes ingresar caracteres especiales");
      return errors;
    },
    cellPhone2ErrorMessages: function cellPhone2ErrorMessages() {
      var errors = [];
      if (!this.$v.cellPhone2.$dirty) return errors;
      !this.$v.cellPhone2.required && errors.push("Campo obligatorio"), !this.$v.cellPhone2.numeric && errors.push("Ingrese sólo números"), !this.$v.cellPhone2.minLength && errors.push("Ingrese mínimo 9 números");
      return errors;
    },
    landline2ErrorMessages: function landline2ErrorMessages() {
      var errors = [];
      if (!this.$v.landline2.$dirty) return errors;
      !this.$v.landline2.required && !(typeof this.$v.landline2.required == "undefined") && errors.push("Campo obligatorio"), !this.$v.landline2.numeric && errors.push("Ingrese sólo números"), !this.$v.landline2.minLength && errors.push("Ingrese mínimo 6 números");
      return errors;
    },
    isTemporalAffiliationOrIsSameCommercialAddress: function isTemporalAffiliationOrIsSameCommercialAddress() {
      return this.membershipType.type === affiliationTypeEnum.TEMPORAL || this.isTheSameDirection === true ? true : false;
    },
    blockErrorMessages: function blockErrorMessages() {
      return [!this.$v.block1.$dirty || this.$v.block1.charactersSpecial || "No puedes ingresar caracteres especiales"].filter(function (val) {
        return typeof val == "string";
      });
    },
    blockErrorMessages2: function blockErrorMessages2() {
      return [!this.$v.block2.$dirty || this.$v.block2.charactersSpecial || "No puedes ingresar caracteres especiales"].filter(function (val) {
        return typeof val == "string";
      });
    },
    allotmentErrorMessages: function allotmentErrorMessages() {
      return [!this.$v.allotment1.$dirty || this.$v.allotment1.charactersSpecial || "No puedes ingresar caracteres especiales"].filter(function (val) {
        return typeof val == "string";
      });
    },
    allotmentErrorMessages2: function allotmentErrorMessages2() {
      return [!this.$v.allotment2.$dirty || this.$v.allotment2.charactersSpecial || "No puedes ingresar caracteres especiales"].filter(function (val) {
        return typeof val == "string";
      });
    },
    km1ErrorMessages: function km1ErrorMessages() {
      return [!this.$v.km1.$dirty || this.$v.km1.numeric || "Ingrese sólo números"].filter(function (val) {
        return typeof val == "string";
      });
    },
    km2ErrorMessages: function km2ErrorMessages() {
      return [!this.$v.km2.$dirty || this.$v.km2.numeric || "Ingrese sólo números"].filter(function (val) {
        return typeof val == "string";
      });
    },
    interior1ErrorMessages: function interior1ErrorMessages() {
      var errors = [];
      if (!this.$v.interior1.$dirty) return errors;

      !this.$v.interior1.charactersSpecial && errors.push("No puedes ingresar caracteres especiales"), !this.$v.interior1.required && !(typeof this.$v.interior1.required == "undefined") && errors.push("Campo obligatorio");

      return errors;
    },
    interior2ErrorMessages: function interior2ErrorMessages() {
      var errors = [];
      if (!this.$v.interior2.$dirty) return errors;

      !this.$v.interior2.charactersSpecial && errors.push("No puedes ingresar caracteres especiales"), !this.$v.interior2.required && !(typeof this.$v.interior2.required == "undefined") && errors.push("Campo obligatorio");
      return errors;
    }
  }),
  mounted: function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var tempMulti;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (this.multiAdress.length > 0) {
                tempMulti = _JSON$stringify(this.multiAdress);

                this.multiDirections = JSON.parse(tempMulti);
                this.isMultiAdress = true;
              }
              if (this.$store.state.affiliations.form.productChoice === "POS Inalámbrico") {
                this.setEsPOSPinpadMpos("POS01");
              } else if (this.$store.state.affiliations.form.productChoice === "POS fijo Internet") {
                this.setEsPOSPinpadMpos("POS02");
              }

              this.getMdelPosByProduct();
              this.validateType();
              this.getInfo();
              console.warn(this.$v);
              console.log("CHECKKK");
              this.getMdelPosByProduct();
              this.loadAgents();
              this.loadAffilitationTypes();

            case 10:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function mounted() {
      return _ref20.apply(this, arguments);
    }

    return mounted;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/business-data.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/business-data.vue
// module chunks = 0 1 2 3